// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"99bee23a","239":"5ed3d066","455":"03079160","762":"6b94573d","977":"70b13b08"}[chunkId] + ".chunk.js";
};